var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index-page"},[_c('div',{staticClass:"router-view-wrapper"},[_c('keep-alive',{attrs:{"include":['Home', 'Hot',  'Apps', 'ShorVideoSearch', 'Community','Publish', 'longVideoSearch']}},[_c('router-view',{staticClass:"router-view"})],1)],1),_c('public-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }